import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

// Create axios instance
const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
});

// Request interceptor - Add token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      
      // If it's a login request failing with 401, just reject (let LoginPage handle it)
      if (isLoginRequest) {
        console.log('[AUTH] Login request failed with 401 - invalid credentials');
        return Promise.reject(error);
      }
      
      // For other 401 errors (expired token), redirect to login
      if (!currentPath.includes('/login')) {
        console.log('[AUTH] Token expired, redirecting to login');
        toast.error('Sessão expirada. Faça login novamente.');
        
        // Clear token and redirect to login
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        
        // Redirect to login after a short delay
        setTimeout(() => {
          window.location.href = '/login';
        }, 1500);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
